import { RootState } from "store";

import { filter, reduce } from "lodash-es";

export const getWyshTermLifeOffering = (state: RootState) => {
  const termOfferings = filter(state.productOffering.byId, ["productSlug", "wysh-term-life"]);
  const latestTermOffer = reduce(termOfferings, (latestOffer, offering) => {
    return latestOffer?.createdAt > offering.createdAt ? latestOffer : offering;
  });

  return latestTermOffer?.status === "expired" ? undefined : latestTermOffer;
};

export const getWyshADOffering = (state: RootState) => {
  const ADOfferings = filter(state.productOffering.byId, ["productSlug", "wysh-accidental-death"]);
  const latestADOffer = reduce(ADOfferings, (latestOffer, offering) => {
    return latestOffer?.createdAt > offering.createdAt ? latestOffer : offering;
  });

  return latestADOffer;
};

export const getCurrentProductOffer = (state: RootState) => {
  const termOffer = getWyshTermLifeOffering(state);
  const adOffer = getWyshADOffering(state);

  return termOffer || adOffer;
};
